<template>
    <div class="pro_container">
        <!-- 头部 -->
        <v-header2></v-header2>
        <!-- 产品标题 -->
        <product-tool title="F50" color="#ffffff"></product-tool>
        <!-- 产品图片 -->
        <img class="pro_img" src="http://wx1.sinaimg.cn/large/0067mezugy1g6ul4n5y5uj31hc0rswha.jpg"/>
        <img class="pro_img_mb" src="http://wx4.sinaimg.cn/large/0067mezugy1g5ra7d4fjij30ku0rs3zu.jpg"/>
        <!-- 产品颜色切换效果 -->
        <div class="pro_animation2" :style="{width: clientWidth * 0.625 + 'px'}">
            <div>
                <p style=" margin-top: 250px;"><img :width="clientWidth * 0.20" src="http://wx2.sinaimg.cn/large/0067mezugy1g6ulb9ytdoj30b204vaa9.jpg"/></p>
                <!-- <p style="width: 390px; margin-top: 250px;">声囊Pro2.0一改以往黑白风格，运用多元素混搭和多色彩组合，设计上体现丰富层次感，机身表面采用铝合金阳极氧化工艺，使视觉效果呈现更为出色。</p> -->
                <h4 style="font-size: 14px; color: #999; margin-top: 330px;">可选颜色</h4>
                <div class="pro_color_box">
                    <ul>
                        <li :class="{active: seletedColor == 0}" @click="switchColor(0)"><i></i>科幻蓝</li>
                        <li :class="{active: seletedColor == 1}" @click="switchColor(1)"><i></i>魔力红</li>
                        <li :class="{active: seletedColor == 2}" @click="switchColor(2)"><i></i>星际黑</li>
                    </ul>
                </div>
            </div>
            <div>
                <swiper :options="swiperOption" v-if="seletedColor === 0">
                    <!-- slides -->
                    <swiper-slide v-for="(item, index) in earphones1" :key="index">
                        <div class="pro_animation_item"><img :src="item" /></div>
                    </swiper-slide>
                    <!-- Optional controls -->
                    <div class="swiper-pagination"  slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                    <div class="swiper-button-next" slot="button-next"><i></i></div>
                </swiper>
                <swiper :options="swiperOption" v-else-if="seletedColor === 1">
                    <!-- slides -->
                    <swiper-slide v-for="(item, index) in earphones2" :key="index">
                        <div class="pro_animation_item"><img :src="item" /></div>
                    </swiper-slide>
                    <!-- Optional controls -->
                    <div class="swiper-pagination"  slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                    <div class="swiper-button-next" slot="button-next"><i></i></div>
                </swiper>
                <swiper :options="swiperOption" v-else>
                    <!-- slides -->
                    <swiper-slide v-for="(item, index) in earphones3" :key="index">
                        <div class="pro_animation_item"><img :src="item" /></div>
                    </swiper-slide>
                    <!-- Optional controls -->
                    <div class="swiper-pagination"  slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                    <div class="swiper-button-next" slot="button-next"><i></i></div>
                </swiper>
            </div>
        </div>
        <!-- 移动端轮播图 -->
        <div class="pro_animation">
            <div>
                <swiper :options="swiperOption" v-if="seletedColor === 0">
                    <!-- slides -->
                    <swiper-slide v-for="(item, index) in earphones1" :key="index">
                        <div class="pro_animation_item"><img :src="item" /></div>
                    </swiper-slide>
                    <!-- Optional controls -->
                    <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                    <div class="swiper-button-next" slot="button-next"><i></i></div>
                </swiper>
                <swiper :options="swiperOption" v-else-if="seletedColor === 1">
                    <!-- slides -->
                    <swiper-slide v-for="(item, index) in earphones2" :key="index">
                        <div class="pro_animation_item"><img :src="item" /></div>
                    </swiper-slide>
                    <!-- Optional controls -->
                    <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                    <div class="swiper-button-next" slot="button-next"><i></i></div>
                </swiper>
                <swiper :options="swiperOption" v-else>
                    <!-- slides -->
                    <swiper-slide v-for="(item, index) in earphones3" :key="index">
                        <div class="pro_animation_item"><img :src="item" /></div>
                    </swiper-slide>
                    <!-- Optional controls -->
                    <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                    <div class="swiper-button-next" slot="button-next"><i></i></div>
                </swiper>
                <div class="pro_color_box">
                    <ul>
                        <li :class="{active: seletedColor == 0}" @click="switchColor(0)"><i></i>科幻蓝</li>
                        <li :class="{active: seletedColor == 1}" @click="switchColor(1)"><i></i>魔力红</li>
                        <li :class="{active: seletedColor == 2}" @click="switchColor(2)"><i></i>星际黑</li>
                    </ul>
                </div>
            </div>
            <p style="text-align: center; margin: 0.8533rem auto;"><img style=" width: 11.84rem;" src="http://wx2.sinaimg.cn/large/0067mezugy1g6ukuxcjshj30ff038dg2.jpg"/></p>
            <!-- <p style="width: 12.6133rem; margin: 40px auto; text-align: left; line-height: 25px;">声囊Pro2.0一改以往黑白风格，运用多元素混搭和多色彩组合，设计上体现丰富层次感，机身表面采用更为复杂的二次氧化工艺，使视觉效果呈现更为出色。</p> -->
        </div>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g6ul4npsorj31hc0rstcc.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g6ul4ohfwwj31hc0rs76m.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g6ul4p6mytj31hc0rs77h.jpg"/>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g6ul4ptlv5j31hc0rswgg.jpg"/>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g6ul4qcctij31hc0rsjtz.jpg"/>
        <img class="pro_img" src="http://wx2.sinaimg.cn/large/0067mezugy1g6ul4qyc4cj31hc0rs0ut.jpg"/>
        <img class="pro_img" src="http://wx1.sinaimg.cn/large/0067mezugy1g6ul4rg9l0j31hc0rswgr.jpg"/>
        <img class="pro_img" src="http://wx2.sinaimg.cn/large/0067mezugy1g6ul4s0sa4j31hc0rsjst.jpg"/>
        <img class="pro_img" src="http://wx2.sinaimg.cn/large/0067mezugy1g6ul4so1yhj31hc0rsq5x.jpg"/>
        <img class="pro_img" src="http://wx1.sinaimg.cn/large/0067mezugy1g6ul4t6hryj31hc0rsagi.jpg"/>
        <img class="pro_img" src="http://wx1.sinaimg.cn/large/0067mezugy1g6ul4todb8j31hc0kl75l.jpg"/>
        <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g5ra7doqyaj30ku0rtaf2.jpg"/>
        <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g5ra7e0dykj30ku0rsq5k.jpg"/>
        <img class="pro_img_mb" src="http://wx2.sinaimg.cn/large/0067mezugy1g6ukuyhsq3j30ku0rt0un.jpg"/>
        <img class="pro_img_mb" src="http://wx4.sinaimg.cn/large/0067mezugy1g6ukuyyrqjj30ku0rs0u9.jpg"/>
        <img class="pro_img_mb" src="http://wx4.sinaimg.cn/large/0067mezugy1g5ra7fmx8bj30ku0rsjt9.jpg"/>
        <img class="pro_img_mb" src="http://wx3.sinaimg.cn/large/0067mezugy1g5ra7g2t0xj30ku0rs75d.jpg"/>
        <img class="pro_img_mb" src="http://wx4.sinaimg.cn/large/0067mezugy1g5ra7gjhw8j30ku0rsaba.jpg"/>
        <v-footer2></v-footer2>
    </div>
</template>

<script>
import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper'
export default {
    components: {
        swiper,
        swiperSlide
    },
    data(){
        return {
            swiperOption: {
                // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                notNextTick: true,
                // swiper configs 所有的配置同swiper官方api配置
                autoplay: 3000,
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: true,
                pagination: '.swiper-pagination',
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
                paginationClickable: true,
                loop: true,
                // mousewheelControl : true,
                observeParents: true,
                // if you need use plugins in the swiper, you can config in here like this
                // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
                debugger: true,
            },
            seletedColor: 0,
            earphones3: ["http://wx4.sinaimg.cn/large/0067mezugy1g5r898nggyj306b0h3q2z.jpg", "http://wx1.sinaimg.cn/large/0067mezugy1g5r8991ecjj30630gk3yl.jpg", "http://wx1.sinaimg.cn/large/0067mezugy1g5r899fy3zj30640dw0so.jpg"],
            earphones2: ["http://wx3.sinaimg.cn/large/0067mezugy1g5r89ahq8zj30690gy0su.jpg", "http://wx3.sinaimg.cn/large/0067mezugy1g5r89b5y4xj30670g4q33.jpg", "http://wx1.sinaimg.cn/large/0067mezugy1g5r89cagpcj30640dwmx5.jpg"],
            earphones1: ["http://wx1.sinaimg.cn/large/0067mezugy1g5r8creyqej306a0h0aa5.jpg", "http://wx2.sinaimg.cn/large/0067mezugy1g5r8cs3r4gj306l0h1q33.jpg", "http://wx2.sinaimg.cn/large/0067mezugy1g5r8cskyewj30640dw0sp.jpg"],
            clientWidth: document.body.clientWidth
        }
    },
    methods:{
        switchColor(type){
            this.seletedColor = type;
        }
    },
    beforeMount(){
        window.addEventListener("resize", () => {
            this.clientWidth = document.body.clientWidth
        })
    }
}
</script>
<style scoped>

.pro_color_box li:nth-child(1) i::before{
	background: #015f84;
}

.pro_color_box li:nth-child(2) i::before{
	background: #e7212a;
}

.pro_color_box li:nth-child(3) i::before{
	background: #342c2a;
}

@media (max-width: 768px) {
    
    /* .pro_animation_item img{
		width: 4.2667rem;
	} */
}
</style>



// WEBPACK FOOTER //
// src/pages/products/F/f50.vue